import { NavLink } from "react-router-dom";
import { FiEye } from "react-icons/fi";
import { FiEdit } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";
import Delete from "../Modals/delete";
import { use, useState } from "react";
import { connect } from "react-redux";
import { deleteAffiliate } from "../../stores/actions/affiliate.actions.types";
import WithdrawPay from "../Modals/pay";

const AffiliateWithdrawalsTable = ({ affilates, setReload, reload, page }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [affilateId, setAffiliateId] = useState(null);

  const handleDeleteClick = (id) => {
    setAffiliateId(id);
    setIsModalOpen(true);
  };

  return (
    <div className='rounded-[10px] bg-white drop-shadow-1 border-l border-slate-300 dark:border-slate-700 dark:bg-boxdark dark:drop-shadow-none border border-stroke bg-white p-4 shadow-1 dark:border-dark-3 dark:bg-gray-dark dark:shadow-card sm:p-2.5 transition-colors duration-300'>
      <div className='max-w-full overflow-x-auto overflow-y-hidden pb-2'>
        <table className='w-full table-auto'>
          <thead>
            <tr className='bg-[#F7F9FC] dark:bg-black text-left dark:bg-dark-2 transition-colors duration-300'>
              <th className='min-w-[120px] px-4 py-2 font-medium text-dark dark:text-white'>
                Info
              </th>
              <th className='min-w-[120px] px-4 py-2 font-medium text-dark dark:text-white'>
                Amount
              </th>
              <th className='min-w-[180px] px-4 py-2 font-medium text-dark dark:text-white'>
                Method
              </th>

              <th className='min-w-[120px] px-4 py-2 font-medium text-dark dark:text-white'>
                Status
              </th>
              <th className='min-w-[150px] px-4 py-2  font-medium text-dark dark:text-white'>
                Created At
              </th>

              <th className='min-w-[120px] px-4 py-2  font-medium text-dark dark:text-white xl:pr-7.5'>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {affilates.map((affilate, index) => (
              <tr key={affilate?._id} className='text-sm'>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === affilates?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-dark dark:text-white'>
                    {affilate?.payoutMethod?.methodType == "bank"
                      ? affilate?.payoutMethod?.bankName
                      : affilate?.payoutMethod?.methodType == "paypal"
                      ? affilate?.payoutMethod?.paypalEmail
                      : affilate?.payoutMethod?.cryptoWalletAddress}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === affilates?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-dark dark:text-white'>
                    ${affilate?.amount}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pr-7.5 ${
                    index === affilates?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5
                    className={`rounded-full px-2 capitalize text-sm  text-black dark:text-white `}
                  >
                    {affilate?.payoutMethod?.methodType}
                  </h5>
                </td>

                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pr-7.5 ${
                    index === affilates?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5
                    className={`text-dark rounded-full px-2 text-center text-sm capitalize text-white  ${
                      affilate?.status === "paid"
                        ? " bg-green-600"
                        : affilate?.status === "pending"
                        ? "bg-yellow-600"
                        : "bg-red-500"
                    }`}
                  >
                    {affilate?.status}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === affilates?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-dark dark:text-white'>
                    {new Date(affilate?.createdAt).toLocaleDateString()}
                  </h5>
                </td>
                {/* <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === affilates?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-dark dark:text-white'>
                    {new Date(affilate?.updatedAt).toLocaleDateString()}
                  </h5>
                </td> */}
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pr-7.5 ${
                    index === affilates?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <div className='flex items-center justify-end space-x-3.5'>
                    {/* Details button */}
                    <div className='group relative'>
                      <NavLink to={`/withdraw/details/${affilate?._id}`}>
                        <button className='mt-[7px] hover:text-primary'>
                          <FiEye className='text-lg' />
                        </button>
                      </NavLink>

                      <span className='absolute left-1/2 top-full w-[80px] -translate-x-1/2 transform rounded  bg-gray-7 px-2 py-1 text-xs text-black opacity-0 transition-opacity  duration-500 group-hover:opacity-100 dark:bg-gray-800 dark:text-white'>
                        Details
                      </span>
                    </div>
                    {affilate?.status === "pending" && page !== "affiliate" ? (
                      <div>
                        <button
                          className='bg-primary px-3 py-0.5 rounded text-white'
                          onClick={() => handleDeleteClick(affilate?._id)}
                        >
                          Pay
                        </button>
                      </div>
                    ) : (
                      <div className='w-[45px] px-3 py-0.5'></div>
                    )}
                    {/* <div className='group relative'>
                      <button
                        className='mt-[7px] hover:text-primary'
                        onClick={() => handleDeleteClick(affilate?._id)}
                      >
                        <FiTrash2 className='text-lg' />
                      </button>

                      <span className='absolute left-1/2 top-full w-[50px] -translate-x-1/2 transform rounded  bg-gray-7 px-2 py-1 text-xs text-white opacity-0 transition-opacity  duration-500 group-hover:opacity-100 dark:bg-white dark:text-gray-700'>
                        Delete
                      </span>
                    </div> */}
                    {/* Delete button */}
                    <WithdrawPay
                      opened={isModalOpen}
                      setOpend={setIsModalOpen}
                      title='Affiliate Payment'
                      id={affilateId}
                      reload={reload}
                      setReload={setReload}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });
export default connect(mapStateToProps, { deleteAffiliate })(
  AffiliateWithdrawalsTable
);
